/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonCompanyBranch,
    JsonCompanyBranchFromJSON,
    JsonCompanyBranchFromJSONTyped,
    JsonCompanyBranchToJSON,
} from './JsonCompanyBranch';

/**
 * 
 * @export
 * @interface ApiResultOfJsonCompanyBranch
 */
export interface ApiResultOfJsonCompanyBranch {
    /**
     * 
     * @type {JsonCompanyBranch}
     * @memberof ApiResultOfJsonCompanyBranch
     */
    data?: JsonCompanyBranch;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyBranch
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonCompanyBranch
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyBranch
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyBranch
     */
    result?: ApiResultOfJsonCompanyBranchResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonCompanyBranchResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonCompanyBranchFromJSON(json: any): ApiResultOfJsonCompanyBranch {
    return ApiResultOfJsonCompanyBranchFromJSONTyped(json, false);
}

export function ApiResultOfJsonCompanyBranchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonCompanyBranch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonCompanyBranchFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonCompanyBranchToJSON(value?: ApiResultOfJsonCompanyBranch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonCompanyBranchToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

